import {
  BankAccountFieldType,
  Currencies,
  ExtendedCurrencies,
} from '@constants/enums';
import { CurrencyType } from '../types';

export const getAccountFieldType = (
  currency: CurrencyType
): BankAccountFieldType => {
  switch (currency) {
    case Currencies.MXN:
      return BankAccountFieldType.CLABE;
    case ExtendedCurrencies.EUR:
    case ExtendedCurrencies.GBP:
      return BankAccountFieldType.IBAN;
    case Currencies.USD:
    case ExtendedCurrencies.CAD:
    default:
      return BankAccountFieldType.ACCOUNT_NUMBER;
  }
};

export const getAccountFieldTranslationKey = (
  fieldType: BankAccountFieldType,
  currency: CurrencyType,
  isAwActive = false
): string => {
  switch (fieldType) {
    case BankAccountFieldType.CLABE:
      return 'afnClabe';
    case BankAccountFieldType.IBAN:
      return 'afnIban';
    case BankAccountFieldType.ACCOUNT_NUMBER:
      if (currency === Currencies.USD && !isAwActive) {
        return 'afnClabe';
      }
      return 'afnAccountNumber';
    case BankAccountFieldType.ACH_ROUTING:
      return 'afnAchRoutingNumber';
    case BankAccountFieldType.WIRE_ROUTING:
      return 'afnWireRoutingNumber';
    case BankAccountFieldType.TRANSIT_NUMBER:
      return 'afnTransitNumber';
    case BankAccountFieldType.INSTITUTION_NUMBER:
      return 'afnInstitutionNumber';
    default:
      return 'afnAccountNumber';
  }
};
